export default __webpack_public_path__ + "static/media/gubee-logo.49ab3197.svg";